/**
 * Decide whether the navigator's "+ toevoegen" opens a picker or creates a blank
 * element directly. Effects always get the chooser (the Meetstandaard is always
 * available); mechanismen always get one too — not an external source, but the
 * werkzame-mechanismen taxonomy itself, so several can be ticked at once;
 * doelgroepen/activiteiten only when the org has parent portfolios.
 * AI-CONTEXT: See docs/features/done/toc-navigator-add-chooser.md
 *
 * @param {string} step - Navigator step ('doel' | 'act' | 'mech' | 'eff')
 * @param {Array<string> | undefined | null} parentPortfolioIds - CompagnyMeta.Parent of the org
 * @returns {'chooser' | 'direct'}
 */
const resolveAddMode = (step, parentPortfolioIds) => {
    const hasPortfolios = Array.isArray(parentPortfolioIds) && parentPortfolioIds.length > 0;

    if (step === 'eff' || step === 'mech') return 'chooser';
    if (step === 'doel' || step === 'act') return hasPortfolios ? 'chooser' : 'direct';
    return 'direct';
};

export default resolveAddMode;
